import { render } from "./NotificationSelectionType.vue?vue&type=template&id=bf5146a2&scoped=true&ts=true"
import script from "./NotificationSelectionType.vue?vue&type=script&lang=ts"
export * from "./NotificationSelectionType.vue?vue&type=script&lang=ts"

import "./NotificationSelectionType.vue?vue&type=style&index=0&id=bf5146a2&scoped=true&lang=css"

import exportComponent from "D:\\Ventla Code\\New Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf5146a2"]])

export default __exports__